/* unplugin-vue-components disabled */import script from "./FormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FormItem.vue?vue&type=script&setup=true&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=1e39b212&lang=scss"

const __exports__ = script;

export default __exports__